import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24693336"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chartContainer"
}
const _hoisted_2 = { ref: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.summaryChartVM)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512)
      ]))
    : _createCommentVNode("", true)
}